<template>
  <div class="buttonarea">
    <el-link :underline="false" v-if="!isEditMode && !isAddMode">
      <el-button
        size="small"
        round
        @click="
          onEdit();
        "
      >
        <i class="iconfont">&#xe618;</i>
        {{$t('message.编辑')}}
      </el-button>
    </el-link>

    <el-link :underline="false" v-if="isEditMode && !isAddMode">
      <el-button
        size="small"
        round
        @click="
          onCancel();
        "
      >
        <i class="iconfont">&#xe600;</i>
        {{$t('message.取消')}}
      </el-button>
    </el-link>

    <el-link :underline="false" v-if="!isAddMode">
      <el-button size="small" round @click="onRefresh()">
        <i class="iconfont">&#xe667;</i>
        {{$t('message.刷新')}}
      </el-button>
    </el-link>

    <el-link :underline="false" v-if="isEditMode && !isAddMode">
      <el-button size="small" round type="primary" @click="onSave()">
        <i class="iconfont">&#xe769;</i>
        {{$t('message.保存')}}
      </el-button>
    </el-link>

    <el-link :underline="false" v-if="!isEditMode && isAddMode">
      <el-button
        size="small"
        round
        @click="
          onBack();
        "
      >
        <i class="el-icon-back"></i>
        {{$t('message.返回')}}
      </el-button>
    </el-link>

    <el-link :underline="false" v-if="!isEditMode && isAddMode">
      <el-button size="small" round type="primary" @click="onAdd()">
        <i class="el-icon-plus"></i>
        {{$t('message.添加')}}
      </el-button>
    </el-link>
  </div>
</template>

<script>
export default {
  name: "OrgButtonArea",

  data() {
    return {
    };
  },

  props: {
    isAddMode: false,
    isEditMode: false,
  },

  methods: {
    onEdit() {
      this.$emit("onEdit");
    },

    onCancel() {
      this.$emit("onCancel");
    },

    onRefresh() {
      this.$emit("onRefresh");
    },

    onSave() {
      this.$emit("onSave");
    },

    onBack(){
      this.$emit("onBack");
    },

    onAdd(){
      this.$emit("onAdd");
    },
  },

  watch: {
    isAddMode: {
      handler(val, oldVal) {},
      immediate: true,
      deep: true,
    },
    isEditMode:{
      handler(val, oldVal) {},
      immediate: true,
      deep: true,
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Organization/OrgButtonArea.vue